<template>
  <v-app>
    <!-- <Mapcovid></Mapcovid>
    <Header></Header>
    <Detail></Detail> -->
    <router-view></router-view>

  </v-app>
</template>

<script>
// import Header from "./components/Header.vue";
// import Detail from "./components/Detail.vue";
// import Mapcovid from "./views/Map.vue";

export default {
  name: "App",
  components: {
    // Mapcovid
    // Header,
    // Detail
  },
  data() {
    return { width: 0, height: 0, isMobileDisplay: false };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    if (window.innerWidth < 599) {
      self.isMobileDisplay = true;
    }
    if(typeof parent != 'undefined' && parent) {
      parent.postMessage(document.body.scrollHeight, '*');
    }
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      if(typeof parent != 'undefined' && parent) {
        parent.postMessage(document.body.scrollHeight, '*');
      }
    }
  }
};
</script>

<style>
body,
html {
  margin: 0px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: scroll;
}
.home-container {
  /* max-width: 1000px; */
  margin: auto;
  background-color: #f7f7f7;
  text-align: center;
  width: 100%;
}
#app {
  font-family: "Prompt", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* max-width: 1000px; */
  margin: auto;
  text-align: center;
  width: 100%;
  /* max-width: 1000px; */
  /* height: 100%; */
  margin: auto;
  background-color: #f7f7f7;
  /* margin-top: 60px; */
}
.apexcharts-title-text,
.apexcharts-legend-text {
  font-family: "Prompt", Avenir, Helvetica, Arial, sans-serif !important;
}
.apexcharts-legend {
  bottom: 0px;
}
.header {
  /* height: 300px; */
}
.detail {
  /* height: calc(100% - 300px); */
  /* height: 500px; */
      /* height: 100%; */
}
.ldmap_placeholder .ldmap_frame .ldmap_geomlabel {
  background-color: #ffffff;
  color: #000;
}
.popupPlace {
  background-color: #ffffff;
  border-radius: 10px;
  width: 100%;
  position: absolute;
  bottom: 0px;
  min-width: 140px;
  padding: 15px;
  margin-left: -80px;
  /* height: 100%; */
  display:flex;
  flex-direction:column;
  justify-content:center;
  /* align-items:center; */
}
.popupLine {
  background: #CDCDCD;
  border-radius: 10px;
  height: 1px;
  margin-top: 8px;
}
.popupFont {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 4px 0px;
}
.popup-tip-container {
  width: 40px;
  height: 20px;
  position: absolute;
  left: 50%;
  margin-left: -20px;
  overflow: hidden;
  pointer-events: none;
}
.popup-tip {
  width: 17px;
  height: 17px;
  padding: 1px;
  margin: -10px auto 0;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  background: white;
  color: #333;
  box-shadow: 0 3px 14px rgba(0,0,0,0.4);
}
.v-data-table__wrapper {
}
.ldmap_placeholder .ldmap_frame .ldmap_popup {
  width: 180px;
}

a[href='https://truehits.net/stat.php?login=longdo'] {
  display:none;
}
img[src^="https://ms.simplethai.net"], img[src^="https://ms.longdo.com"] {
  filter: grayscale(1);
}
.ldmap_placeholder a:hover,
.ldmap_placeholder a:active {
  text-decoration: none !important;
}

@media only screen and (max-width: 600px) {
  body {
  }
}
</style>
